import LogoutIcon from "../../../../svgs/logoutIcon";
export const profileMenus = [
  {
    id: "logout",
    label: "Log out",
    path: "logout",
    icon: <LogoutIcon />,
  },
];
